/**
 * markdown-it plugin: Obsidian-style callouts
 *
 * Syntax:
 *   > [!type] Optional title
 *   > body text
 *
 * Append + or - after the type for collapsible callouts:
 *   > [!warning]+ open by default
 *   > [!danger]-  closed by default
 *
 * Design: the core rule only annotates the existing blockquote_open token
 * with data-callout attributes and removes the [!type] title paragraph from
 * the token stream. The renderer rules then emit the callout HTML. This keeps
 * the token stream structurally intact (blockquote_open / … / blockquote_close)
 * so that markdown-it-pandoc-renderer still sees valid blockquote tokens and
 * can produce a working Pandoc AST for the pandoc export path.
 *
 * ES6-only — no optional chaining, no nullish coalescing.
 */

var CALLOUT_RE = /^\[!(\w+)\]([+-]?)\s*([\s\S]*)/;

var icons = {
  note:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg>',
  info:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
  todo:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
  warning:   '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  caution:   '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  attention: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  danger:    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
  error:     '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
  bug:       '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
  success:   '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
  check:     '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
  done:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
  tip:       '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8.56" y1="2" x2="8.56" y2="6"/><line x1="15.44" y1="2" x2="15.44" y2="6"/><path d="M6 13a6 6 0 0 1 12 0c0 3-2 5-2 8H8c0-3-2-5-2-8z"/><line x1="9" y1="21" x2="15" y2="21"/></svg>',
  hint:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8.56" y1="2" x2="8.56" y2="6"/><line x1="15.44" y1="2" x2="15.44" y2="6"/><path d="M6 13a6 6 0 0 1 12 0c0 3-2 5-2 8H8c0-3-2-5-2-8z"/><line x1="9" y1="21" x2="15" y2="21"/></svg>',
  important: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>',
  example:   '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>',
  abstract:  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="7" y2="18"/></svg>',
  summary:   '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="7" y2="18"/></svg>',
  tldr:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="7" y2="18"/></svg>',
  question:  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  faq:       '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  help:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  quote:     '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/></svg>',
  cite:      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/></svg>',
};

var defaultIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';

function getIcon(type) {
  return icons[type] || defaultIcon;
}

function callouts(md) {
  // ── Core rule ────────────────────────────────────────────────────────────
  // Annotates blockquote_open tokens that are callouts and removes the
  // [!type] title paragraph from the token stream. The blockquote structure
  // (blockquote_open / … / blockquote_close) is preserved so that
  // markdown-it-pandoc-renderer continues to work for pandoc exports.
  md.core.ruler.push('callouts', function (state) {
    var tokens = state.tokens;
    var i;

    for (i = 0; i < tokens.length; i++) {
      if (tokens[i].type !== 'blockquote_open') {
        continue;
      }

      var bqOpen = i;

      // Find the first inline token inside this blockquote (not nested).
      var firstInline = -1;
      var depth = 0;
      var j;
      for (j = bqOpen + 1; j < tokens.length; j++) {
        if (tokens[j].type === 'blockquote_open') {
          depth++;
        } else if (tokens[j].type === 'blockquote_close') {
          if (depth === 0) break; // reached our matching close
          depth--;
        } else if (tokens[j].type === 'inline' && depth === 0) {
          firstInline = j;
          break;
        }
      }

      if (firstInline === -1) {
        continue;
      }

      var inlineToken = tokens[firstInline];
      var match = inlineToken.content.match(CALLOUT_RE);

      if (!match) {
        continue;
      }

      var calloutType = match[1].toLowerCase();
      var foldChar = match[2]; // '+', '-', or ''
      var titleText = match[3].trim();
      if (!titleText) {
        titleText = calloutType.charAt(0).toUpperCase() + calloutType.slice(1);
      }

      // Tag the blockquote_open token with callout metadata.
      tokens[bqOpen].attrSet('data-callout', calloutType);
      tokens[bqOpen].attrSet('data-callout-fold', foldChar);
      tokens[bqOpen].attrSet('data-callout-title', titleText);

      // Remove the title paragraph (paragraph_open, inline, paragraph_close).
      // The inline token is at firstInline; paragraph_open is one before it.
      var paraOpen = firstInline - 1;
      var paraClose = firstInline + 1;
      if (
        paraOpen >= 0 &&
        tokens[paraOpen].type === 'paragraph_open' &&
        paraClose < tokens.length &&
        tokens[paraClose].type === 'paragraph_close'
      ) {
        tokens.splice(paraOpen, 3);
        i--; // blockquote_open index is unchanged, but splice shifted things
      }
    }
  });

  // ── Renderer: blockquote_open ────────────────────────────────────────────
  md.renderer.rules.blockquote_open = function (tokens, idx, options, env, self) {
    var token = tokens[idx];
    var calloutType = token.attrGet('data-callout');

    if (!calloutType) {
      return self.renderToken(tokens, idx, options);
    }

    var foldChar = token.attrGet('data-callout-fold') || '';
    var titleText = token.attrGet('data-callout-title') || calloutType;
    var foldable = foldChar === '+' || foldChar === '-';
    var openByDefault = foldChar === '+';

    var outerTag = foldable
      ? ('<details' + (openByDefault ? ' open' : '') + ' class="callout" data-callout="' + calloutType + '">')
      : ('<div class="callout" data-callout="' + calloutType + '">');
    var titleTag = foldable ? 'summary' : 'div';

    return outerTag + '\n' +
      '<' + titleTag + ' class="callout-title">' +
      '<span class="callout-icon">' + getIcon(calloutType) + '</span>' +
      '<span class="callout-title-inner">' + md.utils.escapeHtml(titleText) + '</span>' +
      (foldable ? '<span class="callout-fold"></span>' : '') +
      '</' + titleTag + '>\n' +
      '<div class="callout-content">\n';
  };

  // ── Renderer: blockquote_close ───────────────────────────────────────────
  md.renderer.rules.blockquote_close = function (tokens, idx, options, env, self) {
    // Walk back to find the matching blockquote_open and check if it's a callout.
    var depth = 1;
    var j;
    for (j = idx - 1; j >= 0; j--) {
      if (tokens[j].type === 'blockquote_close') {
        depth++;
      } else if (tokens[j].type === 'blockquote_open') {
        depth--;
        if (depth === 0) {
          var calloutType = tokens[j].attrGet('data-callout');
          if (calloutType) {
            var foldChar = tokens[j].attrGet('data-callout-fold') || '';
            var foldable = foldChar === '+' || foldChar === '-';
            return '</div>\n' + (foldable ? '</details>\n' : '</div>\n');
          }
          break;
        }
      }
    }
    return self.renderToken(tokens, idx, options);
  };
}

export default callouts;



// WEBPACK FOOTER //
// ./src/extensions/libs/markdownItCallouts.js